import React, { Component } from 'react';

class FeaturesComponent extends Component {
    render () {
        
        const {exterior, interior} = this.props.propertyFeatures;

        const featuresBlock = (title, features) => features && features.length
            ? (
                <div className="features-block">
                    <h3>{title}</h3>
                    <ul>
                        {features.map((feature, i) => {
                            return (
                                <li key={i}>
                                    <span>{feature}</span>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            )
            : null;

        const exteriorBlock = featuresBlock(exterior.title, exterior.data);
        const interiorBlock = featuresBlock(interior.title, interior.data);

        if (!exteriorBlock && !interiorBlock) {
            return null;
        }

        return (
            <div className="features-component">
                {interiorBlock}
                {exteriorBlock}
            </div>
        )
    }
}

export default FeaturesComponent;